import { render, staticRenderFns } from "./GerirStaff.vue?vue&type=template&id=7091a70c&scoped=true"
import script from "./GerirStaff.vue?vue&type=script&lang=js"
export * from "./GerirStaff.vue?vue&type=script&lang=js"
import style0 from "./GerirStaff.vue?vue&type=style&index=0&id=7091a70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091a70c",
  null
  
)

export default component.exports